import { render } from "./ModalConfirmarConcluirProtocolo.vue?vue&type=template&id=7880cdc1"
import script from "./ModalConfirmarConcluirProtocolo.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarConcluirProtocolo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__